module.exports = __webpack_public_path__ + "img/@tmp_hrdcloud_05.97b10400.jpg";